module.exports = __webpack_public_path__ + "media/newstyle/images/laptop-cda-a6eb8ce2a08a534417c16a70432bdad6.png";